import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class NavcontrolService {
  navcontrol = new BehaviorSubject(null);
  navcontrolobject;
  constructor() { }

  updateNavControl() {
    this.navcontrolobject = {
      member: {
        loge: {
          create: true,
          update: true
        },
        lager: {
          create_member: false,
          update_member: false
        }
      },
    };
    this.navcontrol.next(this.navcontrolobject);
  }

  updateNavControlVal(prop, val) {
    this.setDeep(this.navcontrolobject, prop, val);
    this.navcontrol.next(this.navcontrolobject);
  }

  /**
   * Dynamically sets a deeply nested value in an object.
   * Optionally "bores" a path to it if its undefined.
   * @function
   * @param {!object} obj  - The object which contains the value you want to change/set.
   * @param {!array} path  - The array representation of path to the value you want to change/set.
   * @param {!mixed} value - The value you want to set it to.
   * @param {boolean} setrecursively - If true, will set value of non-existing path as well.
   */

  setDeep(obj, path, value, setrecursively = false) {
    let level = 0;
    path.reduce((a, b) => {
      level++;
      if (setrecursively && typeof a[b] === 'undefined' && level !== path.length) {
        a[b] = {};
        return a[b];
      }
      if (level === path.length) {
        a[b] = value;
        return value;
      } else {
        return a[b];
      }
    }, obj);
  }
}
